import LayoutComponent from 'components/layout/layout-component';
import { Typography } from 'components/typography/typography-component';
import { getPage } from 'lib/db/pages';
import { Page } from 'lib/db/types';
import { sanitizeContent } from 'lib/utils/sanitize-content';
import { stripHtmlContent } from 'lib/utils/strip-html';
import { GetStaticProps } from 'next';
import { NextSeo } from 'next-seo';

const PrivacyPage = ({ page }: { page: Page }) => {
  const pageUrl = `${process.env.NEXT_PUBLIC_SITE_URL}/privacy`;

  const { content, title, yoast_head_json: seo } = page || {};

  const privacy = sanitizeContent(`${content.rendered}`);

  const SEO = {
    title: stripHtmlContent(seo?.title) || title.rendered || '',
    description: seo?.description || privacy || '',
    openGraph: {
      type: seo?.og_type || '',
      url: pageUrl,
      site_name: seo?.og_site_name || '',
      title: seo?.og_title || title.rendered || '',
      description: seo?.og_description || privacy || '',
    },
    canonicalUrl: pageUrl,
  };

  return (
    <LayoutComponent>
      <NextSeo {...SEO} />
      <Typography className="my-12 text-center" variant="h1">
        Privacy Policy
      </Typography>
      <div
        className="prose mx-auto mb-12 px-4 md:container prose-a:break-all sm:w-full md:px-0"
        dangerouslySetInnerHTML={{ __html: privacy }}
      />
    </LayoutComponent>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  try {
    const page = await getPage({ slug: 'privacy' });

    if (!page) {
      return { notFound: true };
    }

    return {
      props: {
        page,
      },
      revalidate: 600,
    };
  } catch {
    return { notFound: true };
  }
};

export default PrivacyPage;
